import { useState } from 'react'

import { Modal } from '@/shared'

import style from './PriceErrors.module.scss'
import { Tabs } from './Tabs/Tabs'

interface IProps {
    priceErrors: string[]
    onSetPriceErrors: (priceErrors: string[]) => void
}

export const PriceErrors = (props: IProps) => {
    const { priceErrors, onSetPriceErrors } = props

    const tabs = ['Ошибки в прайсе', 'Правила корректирования']

    const [currentTab, setCurrentTab] = useState(tabs[0])

    const correctionRules =
        'Код услуги предполагает следующий формат:\n- код должен состоять из одного или нескольких звеньев, разделённых точками\n- звено может содержать только строчные или прописные латинские буквы и цифры\nпример: "unit1.unit2.unit3"\n\nСтоимость услуги предполагает следующий формат:\n- стоимость должна быть числом с постфиксом "₽" или "р.",\n- число должно быть положительным больше нуля\n- наличие пробелов между числом и посфиксом, а также разделители целой и дробной части (точка или запятая) допустимы\nпример "1500.50 ₽"\n\nЕдиница измерения предполагает следующий формат:\n- должна представлять собой составное поле, содержащее количество единиц измерений и наименование единицы измерения\n- количество единиц измерений и наименование единицы измерения должны быть разделены не менее чем одним пробелом\n- количество единиц измерений должно представлять собой положительное число от 1\n- наименование единицы измерения должно состоять из алфавитно-цифровых символов\nпример: "1 консультация"'

    return (
        <Modal show={priceErrors.length > 0} onClose={() => onSetPriceErrors([])}>
            <div className={style.container}>
                <Tabs tabs={tabs} onSetTab={setCurrentTab} currentTab={currentTab} />
                {currentTab === 'Ошибки в прайсе' && (
                    <div className={style.errorsWrapper}>
                        {priceErrors.map((error, idx) => (
                            <div key={idx} className={style.error}>
                                <span>{error}</span>
                            </div>
                        ))}
                    </div>
                )}
                {currentTab === 'Правила корректирования' && (
                    <div className={style.instructionsWrapper}>
                        <span>{correctionRules}</span>
                    </div>
                )}
            </div>
        </Modal>
    )
}
